/*
DashboardSidebar Attribution: https://github.com/mui/material-ui/tree/v7.3.4/docs/data/material/getting-started/templates/crud-dashboard
*/
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { ThemeModeContext } from "../styles/AppThemeProvider";

function ThemeSwitcher() {
  const { mode, setMode } = React.useContext(ThemeModeContext);

  const toggleMode = React.useCallback(() => {
    setMode(mode === "dark" ? "light" : "dark");
  }, [setMode, mode]);

  return (
    <Tooltip
      title={`${mode === "dark" ? "Light" : "Dark"} mode`}
      enterDelay={1000}
    >
      <Box
        component="span"
        sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}
        onClick={toggleMode}
      >
        <IconButton
          size="small"
          aria-label={`Switch to ${mode === "dark" ? "light" : "dark"} mode`}
          aria-pressed={mode === "dark"}
          component="span"
        >
          {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
        <Typography variant="body2" component="span" aria-live="polite">
          {mode === "dark" ? "Light Mode" : "Dark Mode"}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export { ThemeSwitcher };
